import { objectToQueryParams } from '../_common/functions'
import { MeasurementTabTypes } from './types'
export const API_URL = process.env.REACT_APP_API_URL
export const APP_ENV = process.env.REACT_APP_ENV
export const STORAGE = 'test-ops'
export const KEYS = {
    AUTH_ACCESS_TOKEN: 'test-ops-auth-access-token',
    AUTH_ACCESS: 'test-ops-auth-access',
    AUTH_REFRESH: 'test-ops-auth-refresh',
    HOME_SSO: 'test-ops-home-sso',
    BUSINESS_OWNER: 'test-ops-business-owner',
    USER: 'test-ops-user',
}
export const showTrendAs = [
    { value: 'positive_upword', label: 'Positive Upward Trend' },
    { value: 'positive_downword', label: 'Positive Downward Trend' },
]
export const cache: Record<string, { data: any; expiry: number }> = {}

export const INSIGHT_COPILOT_PROJECT_KEYS = {
    METHODOLOGY: 'testops_methodology_ghq',
    INSIGHT: 'testops_ghq',
}

export const URLS = {
    REGISTER: '/register',
    REGISTER_APPROVAL: '/register-approval',
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password/:email',
    HOME: '/',
    DASHBOARD: '/dashboard',
    LAYOUT: '/layout',
    DESIGN: '/design',
    SAMPLE_SIZE: '/sample-size',
    PROFILE: '/profile',
    GROUP_CONFIGURE: '/group-configure',
    MY_EXPERIMENTS: '/my-experiments',
    DATA_ONBOARDING: '/data-onboarding',
    CREATE_ONBOARDING: '/create-onboarding',
    UPDATE_ONBOARDING: (literal?: string) => `/update-onboarding/${literal ?? ':literal'}`,
    GLOSSARY: '/glossary',
    ADMIN: '/admin',
    ADMIN_CREATE_EXPERIMENT: '/admin/create-experiment',
    ADMIN_MY_EXPERIMENTS: '/admin/my-experiments',
    ADMIN_RESULT_TRACKING: '/admin/result-tracking',
    ADMIN_LIVE_SIMULATION: '/admin/live-simulation',
    ADMIN_MULTI_TREATMENT: '/admin/multi-treatment',

    PENDING_USER_REQUEST: '/pending-user-request',
    VIEW_EXISTING_USERS: '/view-existing-users',
    CREATE_EXPERIMENT: (experiment?: string) => {
        return `/create-experiment/${experiment ?? ':experiment'}`
    },
    MEASUREMENT: (experiment: string = ':experiment', step: MeasurementTabTypes = ':step', query: string = '') => {
        return `/measurement/${experiment}/${step}${query ? '?' + query : ''}`
    },

    EXPERIMENT_DETAILS: (exptLiteral?: string) => `/experiment/${exptLiteral ?? ':exptLiteral'}`,
    EXPERIMENT_DETAILS_DOWNLOAD: (exptLiteral?: string) => `/experiment/${exptLiteral ?? ':exptLiteral'}/download`,
    AZURE_AUTH: '/azure-auth',
    EXECUTIVE_DASHBOARD: `/executive-dashboard`,
    EXECUTIVE_DASHBOARD_V2: `/executive-dashboard-v2`,
    EXECUTIVE_DASHBOARD_V3: `/executive-dashboard-v3`,
    DOCUMENTAION: {
        'landing-page': {
            url: 'https://anheuserbuschinbev.sharepoint.com/:fl:/g/contentstorage/CSP_bbb5367a-3052-4c89-b5bc-9c85d81db3d0/EaX6_-VDrGVMiaSbmvtQntMB9YpIyQ3ujrtR3p9C9Yflyw?e=KU2NQz',
            pageName: 'Landing Page',
        },
        'sample-size': {
            url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/Product%20WalkThrough/4_Sample_Size/',
            pageName: 'Sample Size',
        },
        'my-experiments': {
            url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/Product%20WalkThrough/1_My_Experiments/',
            pageName: 'My Experiments',
        },
        'data-onboarding': {
            url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/Product%20WalkThrough/2_Data_Onboarding/',
            pageName: 'Data Onboarding',
        },
        'create-onboarding': {
            url: 'https://anheuserbuschinbev.sharepoint.com/:fl:/g/contentstorage/CSP_67c54e1e-6d64-4714-af28-bec92aeaf47e/EbmT_8b8U_VJhmfRBAki8T0BXW1VTpFui36LfI6X7e-o7Q?e=gd1GzQ&nav=cz0lMkZjb250ZW50c3RvcmFnZSUyRkNTUF82N2M1NGUxZS02ZDY0LTQ3MTQtYWYyOC1iZWM5MmFlYWY0N2UmZD1iJTIxSGs3RloyUnRGRWV2S0w3Skt1cjBmcVdCVmVJdXFFbEhnUHduUGZITXlCbDBRREZHcERBRVE3ZWxfUk0tZl8xVCZmPTAxNkc2UFUzRlpTUDc0TjdDVDZWRVlNWjZSQVFFU0Y0SjUmYz0lMkYmYT1Mb29wQXBwJnA9JTQwZmx1aWR4JTJGbG9vcC1wYWdlLWNvbnRhaW5lciZ4PSU3QiUyMnclMjIlM0ElMjJUMFJUVUh4aGJtaGxkWE5sY21KMWMyTm9hVzVpWlhZdWMyaGhjbVZ3YjJsdWRDNWpiMjE4WWlGSWF6ZEdXakpTZEVaRlpYWkxURGRLUzNWeU1HWnhWMEpXWlVsMWNVVnNTR2RRZDI1UVpraE5lVUpzTUZGRVJrZHdSRUZGVVRkbGJGOVNUUzFtWHpGVWZEQXhOa2MyVUZVelFWRkNWbEZJVWtGRlFUYzFSVWxIVWpOUVFVWlNVRlJHVGtnJTNEJTIyJTJDJTIyaSUyMiUzQSUyMjFlMDE1MGNkLTE5OWUtNDY5MC04ZDdiLWJjNjU1ZDY1ZTUzZCUyMiU3RA%3D%3D',
            pageName: 'Create Onboarding',
        },
        'update-onboarding': {
            url: 'https://anheuserbuschinbev.sharepoint.com/:fl:/g/contentstorage/CSP_67c54e1e-6d64-4714-af28-bec92aeaf47e/EbmT_8b8U_VJhmfRBAki8T0BXW1VTpFui36LfI6X7e-o7Q?e=5TjFGS&nav=cz0lMkZjb250ZW50c3RvcmFnZSUyRkNTUF82N2M1NGUxZS02ZDY0LTQ3MTQtYWYyOC1iZWM5MmFlYWY0N2UmZD1iJTIxSGs3RloyUnRGRWV2S0w3Skt1cjBmcVdCVmVJdXFFbEhnUHduUGZITXlCbDBRREZHcERBRVE3ZWxfUk0tZl8xVCZmPTAxNkc2UFUzRlpTUDc0TjdDVDZWRVlNWjZSQVFFU0Y0SjUmYz0lMkYmYT1Mb29wQXBwJnA9JTQwZmx1aWR4JTJGbG9vcC1wYWdlLWNvbnRhaW5lciZ4PSU3QiUyMnclMjIlM0ElMjJUMFJUVUh4aGJtaGxkWE5sY21KMWMyTm9hVzVpWlhZdWMyaGhjbVZ3YjJsdWRDNWpiMjE4WWlGSWF6ZEdXakpTZEVaRlpYWkxURGRLUzNWeU1HWnhWMEpXWlVsMWNVVnNTR2RRZDI1UVpraE5lVUpzTUZGRVJrZHdSRUZGVVRkbGJGOVNUUzFtWHpGVWZEQXhOa2MyVUZVelFWRkNWbEZJVWtGRlFUYzFSVWxIVWpOUVFVWlNVRlJHVGtnJTNEJTIyJTJDJTIyaSUyMiUzQSUyMjFlMDE1MGNkLTE5OWUtNDY5MC04ZDdiLWJjNjU1ZDY1ZTUzZCUyMiU3RA%3D%3D',
            pageName: 'Update Onboarding',
        },
        'create-experiment': [
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/1_Fill_Metadata/#1-create-experiment',
                pageName: 'Create Experiment',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/2_Data_Selection/',
                pageName: 'Data Selection',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/3_Data_Filters_SQL/',
                pageName: 'Data Filters And SQL Query',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/4_Group_Allocation/',
                pageName: 'Group Allocation And Submission',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/5_Final_Submission/',
                pageName: 'Final Group Allocation',
            },
        ],
        measurement: [
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/7_Measurement_Allocation/',
                pageName: 'Measurement Data Selection',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/3_Data_Filters_SQL',
                pageName: 'Measurement Data Filters And SQL Query',
            },
            {
                url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/4_Group_Allocation/',
                pageName: 'Measurement Group Allocation And Submission ',
            },
        ],
        experiment: {
            url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/User%20Guide/8_Experiment%20Results/',
            pageName: 'Insight',
        },
        'executive-dashboard': {
            url: 'https://testops-docs.ab-inbev.com/Product%20User%20Guide/Product%20WalkThrough/3_Executive_Dashboard/',
            pageName: 'Executive Dashboard',
        },
    },
    RAISE_TICKET: 'https://abinbevww.service-now.com/abiex?id=sc_cat_item&sys_id=5ad2235adb1cc050f17eb29f29961934',
    INFO_LINK:
        'https://anheuserbuschinbev.sharepoint.com/:fl:/g/contentstorage/CSP_67c54e1e-6d64-4714-af28-bec92aeaf47e/EdbmRnba7rtDsfqqluF389kBJdXlB26ooacUdITtRwNtfw?e=51GdrS&nav=cz0lMkZjb250ZW50c3RvcmFnZSUyRkNTUF82N2M1NGUxZS02ZDY0LTQ3MTQtYWYyOC1iZWM5MmFlYWY0N2UmZD1iJTIxSGs3RloyUnRGRWV2S0w3Skt1cjBmcVdCVmVJdXFFbEhnUHduUGZITXlCbDBRREZHcERBRVE3ZWxfUk0tZl8xVCZmPTAxNkc2UFUzR1c0WkRITldYT1hOQjNENlZLUzNRWFA0NlomYz0lMkYmYT1Mb29wQXBwJnA9JTQwZmx1aWR4JTJGbG9vcC1wYWdlLWNvbnRhaW5lciZ4PSU3QiUyMnclMjIlM0ElMjJUMFJUVUh4aGJtaGxkWE5sY21KMWMyTm9hVzVpWlhZdWMyaGhjbVZ3YjJsdWRDNWpiMjE4WWlGSWF6ZEdXakpTZEVaRlpYWkxURGRLUzNWeU1HWnhWMEpXWlVsMWNVVnNTR2RRZDI1UVpraE5lVUpzTUZGRVJrZHdSRUZGVVRkbGJGOVNUUzFtWHpGVWZEQXhOa2MyVUZVelFWRkNWbEZJVWtGRlFUYzFSVWxIVWpOUVFVWlNVRlJHVGtnJTNEJTIyJTJDJTIyaSUyMiUzQSUyMjFlMDE1MGNkLTE5OWUtNDY5MC04ZDdiLWJjNjU1ZDY1ZTU0YiUyMiU3RA%3D%3D',

    HOW_IT_WORKS_ANALYSIS_LINK:
        'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9hbmhldXNlcmJ1c2NoaW5iZXYuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQX2JiYjUzNjdhLTMwNTItNGM4OS1iNWJjLTljODVkODFkYjNkMD9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVRjlpWW1JMU16WTNZUzB6TURVeUxUUmpPRGt0WWpWaVl5MDVZemcxWkRneFpHSXpaREFtWkQxaUpUSXhaV3BoTVhVeFNYZHBWWGt4ZGtwNVJqSkNNbm93U2xkNVlrVnNRWHBoV2t4eFdIZFhPVEE1TkRWRVMyNW1XRmxVWHpCTVpGTnZNbVpIZVdONU1uUkJNaVptUFRBeFZqSmFOVmhHTkZKSFZGTlBTRGMzUzB0YVFrc3lNMVpSVlVSRk5WTlFRME1tWXowbE1rWW1ZVDFNYjI5d1FYQndKbkE5SlRRd1pteDFhV1I0SlRKR2JHOXZjQzF3WVdkbExXTnZiblJoYVc1bGNpWjRQU1UzUWlVeU1uY2xNaklsTTBFbE1qSlVNRkpVVlVoNGFHSnRhR3hrV0U1c1kyMUtNV015VG05aFZ6VnBXbGhaZFdNeWFHaGpiVlozWWpKc2RXUkROV3BpTWpFNFdXbEdiR0Z0Ulhoa1ZFWktaREpzVm1WVVJqSlRibXhIVFd0SmVXVnFRa3RXTTJ4cFVsZDRRbVZ0Um1GVVNFWlpaREZqTlUxRWF6Qk9WVkpNWW0xYVdWZFdVbVpOUlhoclZUSTRlVnByWkRWWk0ydDVaRVZGZVdaRVFYaFdha3BoVGxab1IxZHJPVXRSYTJoTFZGVnNVRlZyZUVOUmEzaFVVbFpHUjFSRk9VOVNSbHBTVlVWekpUTkVKVEl5SlRKREpUSXlhU1V5TWlVelFTVXlNbUU0Tm1KaVptTTFMVGN4WldZdE5EUmlPUzFoWkRrM0xUQmhZbUU0T0dZeU56UmpNQ1V5TWlVM1JBPT0ifQ%3D%3D',
    KNOW_MORE_LINK:
        'https://anheuserbuschinbev.sharepoint.com/:fl:/g/contentstorage/CSP_bbb5367a-3052-4c89-b5bc-9c85d81db3d0/IQBqsuijuXb1QbKnIxjIQviHAeHLAwtk23OFqp_1PQzn4FY?e=zxjOeZ&nav=cz0lMkZjb250ZW50c3RvcmFnZSUyRkNTUF9iYmI1MzY3YS0zMDUyLTRjODktYjViYy05Yzg1ZDgxZGIzZDAmZD1iJTIxZWphMXUxSXdpVXkxdkp5RjJCMnowSld5YkVsQXphWkxxWHdXOTA5NDVES25mWFlUXzBMZFNvMmZHeWN5MnRBMiZmPTAxVjJaNVhGM0tXTFVLSE9MVzZWQTNGSlpERERFRUY2RUgmYz0lMkYmYT1Mb29wQXBwJnA9JTQwZmx1aWR4JTJGbG9vcC1wYWdlLWNvbnRhaW5lciZ4PSU3QiUyMnclMjIlM0ElMjJUMFJUVUh4aGJtaGxkWE5sY21KMWMyTm9hVzVpWlhZdWMyaGhjbVZ3YjJsdWRDNWpiMjE4WWlGbGFtRXhkVEZKZDJsVmVURjJTbmxHTWtJeWVqQktWM2xpUld4QmVtRmFUSEZZZDFjNU1EazBOVVJMYm1aWVdWUmZNRXhrVTI4eVprZDVZM2t5ZEVFeWZEQXhWakphTlZoR1drOUtRa2hLVFVsUFVreENRa3hUUlZGR1RFOU9SRlpSVUVzJTNEJTIyJTJDJTIyaSUyMiUzQSUyMjYyYzk2ZmMyLTFlYzEtNDJhNi04MDFkLWYwMTY0NTI1NWE2NiUyMiU3RA%3D%3D',
    DS_AGENT: '/agents/ds-agent',
    DS_AGENT_IC: '/agents/ds-agent-ic',
    AGENTS: '/agents',
    REQUIREMENT_AGENT: '/agents/requirement-agent',
    PLANNING_AGENT: '/agents/planning-agent',
    DEVOPS_AGENT: '/agents/devops-agent',
    CONTROL_CENTER: (section?: 'all-experiments' | 'deleted-experiments' | 'executive-experiments') => `/control-center/${section ?? ':section'}`,
    PREEXISTING_TEMPLATE_LIST(templateid?: string): string {
        return `/preexisting-template-list${templateid ? '/' + templateid : ''}`
    },
}

export const APIS = {
    AUTH: {
        LOGIN: API_URL + '/v1/auth/sso_authorize',
        SSO_INITIATE: API_URL + '/v1/auth/sso_initiate',
        SSO_VERIFY: API_URL + '/v1/auth/sso/verify-token',
        LOGOUT: API_URL + '/v1/auth/logout',
        FORGOT_PASSWORD: API_URL + '/forgot/password',
        RESET_PASSWORD: API_URL + '/set/password',
        CHANGE_PASSWORD: API_URL + '/users/password',
        REGISTRATION: API_URL + '/v1/auth/register',
        AVATAR: API_URL + '/users/avatar',
        REFRESH_TOKEN: `${API_URL}/v1/auth/refresh_token`,
        UPDATE_USER: (literal?: string) => `${API_URL}/v1/users/${literal}`,
    },
    LANDINGPAGE: {
        SUMMARY: API_URL + '/v1/landingpage/summary',
        SITE_SETTINGS: API_URL + '/v1/landingpage/sitesettings',
        CONTACT_US: API_URL + '/v1/landingpage/contactus',
    },
    TESTOPS_GENIE: {
        CONVERSATION: API_URL + '/v1/genai/v2/conversation',
        CHAT: (conversationID: string) => {
            return `${API_URL}/v1/genai/v2/chat/${conversationID}`
        },
        GET_CHAT_BY_CONVERSATION_ID: `${API_URL}/v1/genai/latest-chat`,
        GET_SUGGESTED_QUESTIONS: `${API_URL}/v1/genai/suggested-questions`, // no need product key for this API
        ADD_USER: `${API_URL}/v1/genai/member/add-user`, // pass product_key in payload
        GET_CONVERSATION_LIST: `${API_URL}/v1/genai/v2/conversations`,
        GET_HISTORY: (conversationID: string) => `${API_URL}/v1/genai/v2/conversations/${conversationID}`,
        CHAT_SOCKET: `${API_URL}/v1/genai/v2/conversations/pubsub/negotiate`,
    },
    CHAT_TO_EXPERIMENT: {
        CREATE_SESSION: `${API_URL}/v1/chat-to-experiment/session`,
        CHAT: (sessionId: string) => `${API_URL}/v1/chat-to-experiment/chat/${sessionId}`,
        LIST_SESSIONS: `${API_URL}/v1/chat-to-experiment/sessions`,
        GET_SESSION_MESSAGES: (sessionId: string) => `${API_URL}/v1/chat-to-experiment/session/${sessionId}/messages`,
        DELETE_SESSION: (sessionId: string) => `${API_URL}/v1/chat-to-experiment/session/${sessionId}`,
        CHAT_STEPS_STREAM: `${API_URL}/v1/chat-to-experiment/chat/steps/stream`,
        GET_SUPPORT_NOTE: `${API_URL}/v1/chat-to-experiment/support-note`,
        CREATE_FILTER_SESSION: `${API_URL}/v1/chat-to-experiment/filter-assist/session`,
    },
    DS_AGENT: {
        CREATE_SESSION: `${API_URL}/v1/agents/ds-agent/session`,
        CHAT: (sessionId: string) => `${API_URL}/v1/agents/ds-agent/chat/${sessionId}`,
        LIST_SESSIONS: `${API_URL}/v1/agents/ds-agent/sessions`,
        GET_SESSION_MESSAGES: (sessionId: string) => `${API_URL}/v1/agents/ds-agent/session/${sessionId}/messages`,
        DELETE_SESSION: (sessionId: string) => `${API_URL}/v1/agents/ds-agent/session/${sessionId}`,
        SUBMIT_FEEDBACK: `${API_URL}/v1/agents/ds-agent/feedback`,
    },
    REQUIREMENT_AGENT: {
        CREATE_SESSION: `${API_URL}/v1/agents/requirement-agent/session`,
        CHAT: (sessionId: string) => `${API_URL}/v1/agents/requirement-agent/chat/${sessionId}`,
        LIST_SESSIONS: `${API_URL}/v1/agents/requirement-agent/sessions`,
        GET_SESSION_MESSAGES: (sessionId: string) => `${API_URL}/v1/agents/requirement-agent/session/${sessionId}/messages`,
        DELETE_SESSION: (sessionId: string) => `${API_URL}/v1/agents/requirement-agent/session/${sessionId}`,
        SUBMIT_FEEDBACK: `${API_URL}/v1/agents/requirement-agent/feedback`,
    },
    PLANNING_AGENT: {
        CREATE_SESSION: `${API_URL}/v1/agents/planning-agent/session`,
        CHAT: (sessionId: string) => `${API_URL}/v1/agents/planning-agent/chat/${sessionId}`,
        LIST_SESSIONS: `${API_URL}/v1/agents/planning-agent/sessions`,
        GET_SESSION_MESSAGES: (sessionId: string) => `${API_URL}/v1/agents/planning-agent/session/${sessionId}/messages`,
        DELETE_SESSION: (sessionId: string) => `${API_URL}/v1/agents/planning-agent/session/${sessionId}`,
        SUBMIT_FEEDBACK: `${API_URL}/v1/agents/planning-agent/feedback`,
    },
    DEVOPS_AGENT: {
        CREATE_SESSION: `${API_URL}/v1/agents/devops-agent/session`,
        CHAT: (sessionId: string) => `${API_URL}/v1/agents/devops-agent/chat/${sessionId}`,
        LIST_SESSIONS: `${API_URL}/v1/agents/devops-agent/sessions`,
        GET_SESSION_MESSAGES: (sessionId: string) => `${API_URL}/v1/agents/devops-agent/session/${sessionId}/messages`,
        DELETE_SESSION: (sessionId: string) => `${API_URL}/v1/agents/devops-agent/session/${sessionId}`,
        SUBMIT_FEEDBACK: `${API_URL}/v1/agents/devops-agent/feedback`,
    },

    COMMON: {
        COUNTRY: API_URL + '/v1/countries',
        ZONE: API_URL + '/v1/zones',
        BUSINESS_FUNCTION: API_URL + '/v1/business-functions',
        ROLE: API_URL + '/v1/roles',
        USE_CASES: API_URL + '/v1/use-cases',
        KPI_INTERESTS: API_URL + '/v1/kpis',
        KPI_TYPES: API_URL + '/v1/kpis',
        ALLDROPDOWN: (payload: string) => `${API_URL}/v1/dropdowns/${payload}`,
        EXPERIMENTS_TYPES: API_URL + '/v1/experiment-types',
        USERS: API_URL + '/v1/users',
        EXPT_SHARABLE_USER: (literal: string) => {
            return `${API_URL}/v1/experiments/share/sharable-user-list/${literal}`
        },
        TOP_ACTIVE_USERS: API_URL + '/v1/experiments/executive-dashboard-get-top-active-users',
        EXP_STATUS: API_URL + '/v1/dropdowns/exp-stats',
        ADVANCE_CONFIG_OPTION: API_URL + '/v1/advance-configs',
        PRODUCT_INFO: API_URL + '/v1/product-info',
        GET_CURRENCY: API_URL + '/v1/currency',
        GET_VOLUME: API_URL + '/v1/volume',
        GET_EXPERIMENT_ACCESS: (literal: string) => {
            return `${API_URL}/v1/business-owner/check-experiment-access/${literal}`
        },
        GET_ADVANCE_CONFIG_OPTION: `${API_URL}/v1/sitesettings/form-defaults`,
    },
    EXPERIMENT: {
        CREATE_DESIGN: `${API_URL}/v1/experiments`,
        UPDATE_EXPERIMENT: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}`
        },
        ZONE_DESIGN: (zone: string) => `${API_URL}/v1/zone-designs/${zone}`,
        USER_DESIGN: API_URL + '/v1/user-designs/',
        ZONE_DESIGN_DETAILS: (tableName: string) => `${API_URL}/v1/zone-designs/details/${tableName}`,

        GET_EXPERIMENTS: `${API_URL}/v1/experiments/get-all-experiments`,
        GET_EXPERIMENT_DETAILS: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}`
        },
        GET_CONTAMINATION_CHECK: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/contamination-check`
        },
        POST_CONTAMINATION_SNAPSHOT: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/contamination-snapshot`
        },
        UPDATE_CONTAMINATION_SELECTION: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/contamination-selection`
        },
        DELETE_CONTAMINATION_SNAPSHOT: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/contamination-snapshot`
        },

        GET_COLUMN_PREVIEW_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/get-columns-and-preview-data/${literal}`
        },
        FILTER_PREVIEW_DATA: `${API_URL}/v1/experiments/filter-preview-data`,

        SQL_PREVIEW_DATA: `${API_URL}/v1/experiments/sql-preview-data`,

        GET_EXPERIMENTS_OTHERS: `${API_URL}/v1/experiments/experiments-from-others`,
        USER_DESIGN_CREATE: `${API_URL}/v1/user-designs/create`,
        RECURRING_EXPERIMENT_CREATE: (literal: string) => {
            return `${API_URL}/v1/experiments/create-recurring-experiment/${literal}`
        },
        RECURRING_EXPERIMENT_UPDATE: (literal: string) => {
            return `${API_URL}/v1/experiments/update-recurring-experiment/${literal}`
        },
        RECURRING_UPDATE_DESIGN_TABLE: (literal: string) => {
            return `${API_URL}/v1/experiments/change-recurring-experimrnt-design-table/${literal}`
        },
        RECURRING_GET_DESIGN_TABLE_COLUMNS: (literal: string) => {
            return `${API_URL}/v1/experiments/get-recurring-new-design-column-details/${literal}`
        },
        RECURRING_GET_DESIGN_PREVIEW_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/get-recurring-new-design-preview-data/${literal}`
        },
        RECURRING_UPDATE_DESIGN_CONFIG: (literal: string) => {
            return `${API_URL}/v1/experiments/update-recurring-design-config/${literal}`
        },
        UPLOAD_FILE: (literal: string) => {
            return `${API_URL}/v1/experiments/upload_file/${literal}`
        },
        UPLOAD_RECURRING_MEASUREMENT_FILE: (literal: string) => {
            return `${API_URL}/v1/experiments/upload_recurring_measurement_file/${literal}`
        },
        RECURRING_FILE_PROCESS_WATCH: (literal: string) => {
            return `${API_URL}/v1/experiments/check-recurring-measurement-process-data/${literal}`
        },
        UPLOAD_ADDITIONAL_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/upload-additional-data/${literal}`
        },
        MAP_ADDITIONAL_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/map-additional-data/${literal}`
        },

        REMOVE_EXPERIMENT: (literal: string, reason: string | null) => `${API_URL}/v1/experiments/${literal}?reason=${reason}`,
        CANCEL_EXPERIMENT: (literal: string) => `${API_URL}/v1/experiments/experiment/cancel/${literal}`,
        GET_RCT_GROUP_RESULTS: (literal: string) => {
            return `${API_URL}/v1/experiments/rct-group-result/${literal}`
        },
        EXPORT_RCT_GROUP_RESULTS: (literal: string) => {
            return `${API_URL}/v1/experiments/rct/download/${literal}`
        },
        DOWNLOAD_RCT_GROUP_RESULTS: (literal: string) => {
            return `${API_URL}/v1/experiments/rct/download-link/${literal}`
        },
        DOWNLOAD_RCT_GZIP_RESULTS: (literal: string) => {
            return `${API_URL}/v1/experiments/rct/download-gzip/${literal}`
        },
        PROCESS_VALIDATED_DATA: (literal: string, upload_type: string, adls_file_path_recurring?: string, recurring_file_name?: string) => {
            let url = `${API_URL}/v1/experiments/process-validated-data/${literal}/${upload_type}`
            if (adls_file_path_recurring) {
                url += `?adls_file_path_recurring=${encodeURIComponent(adls_file_path_recurring)}`
            }
            if (recurring_file_name) {
                url += `&recurring_file_name=${encodeURIComponent(recurring_file_name)}`
            }
            return url
        },
        MEASUREMENT_DATA: `${API_URL}/v1/experiments/measurement-data`,
        CARDS: `${API_URL}/v1/experiments/insights/overview/cards`,
        DML_DATA: (literal: string) => `${API_URL}/v1/experiments/insights/dml-data/${literal}`,
        MTE_CARDS: (literal: string) => `${API_URL}/v1/experiments/insights/mte-cards/${literal}`,
        DETAIL_ANALYSIS_DATA: (literal: string) => `${API_URL}/v1/experiments/insights/overview/details-analysis/${literal}`,
        SHARED_USERS: (literal: string) => `${API_URL}/v1/experiments/${literal}/user-list`,
        SHARE_EXPT_TO_USERS: (literal: string) => `${API_URL}/v1/experiments/${literal}/share`,
        EXECUTE_RCT: (literal: string) => {
            return `${API_URL}/v1/experiments/rct/${literal}`
        },
        EXECUTE_RCT_RESULTS: (literal: string) => {
            return `${API_URL}/v1/experiments/rct/result/${literal}`
        },
        GET_COLUMNS_FOR_GROUP_DISTRIBUTION: (literal: string, tableType: string) => {
            return `${API_URL}/v1/experiments/get-columns-for-group-distribution/${literal}/${tableType}`
        },
        GET_DESIGN_KPI_MEASURMENT: (literal: string) => {
            return `${API_URL}/v1/experiments/design-kpi-measurement/${literal}`
        },

        EXECUTE_MEASURMENT_ANALYSIS: (literal: string) => {
            // return `${API_URL}/v1/experiments/execute-measurement-analysis/${literal}`
            return `${API_URL}/v1/experiments/run-aks-jobs/${literal}`
        },

        MEASURMENT_DESIGN_MERGE_OVERVIEW: (literal: string) => {
            return `${API_URL}/v1/experiments/measurement-design-merge-overview/${literal}`
        },
        // GET_EXPERIMENT_PIE_CHART: `${API_URL}/v1/experiments/Executive-Dashboard-Get-Pie-Chart`,
        // GET_EXPERIMENT_FROM_THE_MARKET: `${API_URL}/v1/experiments/Executive-Dashboard-Get-Top-Experiments-From-The-market`,
        MTE_SUBMIT: `${API_URL}/v1/experiments/mte/submit`,
        PLAY_OR_PAUSE: (literal: string, status: string) => {
            return `${API_URL}/v1/experiments/start-or-pause-recurring-experiment/${literal}/${status}`
        },
        MEASUREMENT_GROUP_DISTRIBUTION_DATA: `${API_URL}/v1/experiments/measurement-group-distribution-details`,
        MIGRATE_MEASUREMENT_DATA_TO_CSV: (literal: string) => {
            return `${API_URL}/v1/experiments/measurement-flow/migrate-measurement-data-to-csv/${literal}`
        },
        DESIGN_GROUP_DISTRIBUTION_DETAILS: `${API_URL}/v1/experiments/design-group-distribution-details`,
        GET_KPI_CHART_DATA_BY_DATE: (literal: string) => {
            return `${API_URL}/v1/experiments/observational-study/design/kpi-charts/${literal}`
        },
        GET_OBS_FEATURE_DISTRIBUTION_BAR_CHART: (literal: string) => {
            return `${API_URL}/v1/experiments/observational-study/design/feature-charts/${literal}`
        },
        SAMPLE_SIZE_CALCULATE: `${API_URL}/v1/experiments/estimate-sample-size`,
        AVG_METRIC_DESIGN: (literal: string) => `${API_URL}/v1/experiments/avg-metrics-design/${literal}`,

        ATTACHMENT: {
            UPLAOD: (literal: string) => `${API_URL}/v1/experiments/observational-study/design/feature-chart/${literal}`,
            MAP: `${API_URL}/v1/experiments/observational-study/design/feature-chart/`,
            DELETE: (literal: string) => `${API_URL}/v1/experiments/observational-study/design/feature-chart/${literal}`,
            GET: (literal: string) => `${API_URL}/v1/experiments/observational-study/design/feature-chart/${literal}`,
        },
        ADDITIONAL_FILE_UPLOAD: (literal: string) => {
            return `${API_URL}/v1/experiments/additional-file-upload/${literal}`
        },

        ADDITIONAL_TABLE_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/additional-table/${literal}`
        },
        COMMENTS: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/comments`
        },
        GET_INCONCLUSIVE_REASON: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/inconclusive-reason/${literal}`
        },
        DOWNLOAD_LOG: (literal: string) => {
            return `${API_URL}/v1/experiments/download/logs/${literal}`
        },
        MAKE_PARTIAL: (literal: string) => {
            return `${API_URL}/v1/experiments/partial/${literal}`
        },
        DELETE_INSIGHTS: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/delete/${literal}`
        },
        EXPERIMENT_DROPDOWN: (payload: any) => {
            let str = `${API_URL}/v1/experiments/distinct_values/column/${payload.column_name}`
            const qParams: any = {}

            if (payload.Page) {
                qParams.page = payload.Page
            }
            if (payload.per_page) {
                qParams.per_page = payload.per_page
            }
            if (payload.paginated) {
                qParams.paginated = payload.paginated
            }
            if (payload.filter_value) {
                qParams.filter_value = payload.filter_value
            }
            if (payload?.selectedFilters?.include_is_partial) {
                qParams.include_is_partial = payload?.selectedFilters?.include_is_partial
            }
            if (payload?.selectedFilters?.from_top_learning) {
                qParams.from_top_learning = payload?.selectedFilters?.from_top_learning
            }
            if (payload?.selectedFilters?.my_scope) {
                qParams.my_scope = payload?.selectedFilters?.my_scope
            }

            str += objectToQueryParams(qParams)

            return str
        },
        UPDATE_KPI_UNIT: (literal: string) => {
            return `${API_URL}/v1/experiments/update-kpi-units/${literal}`
        },
        GENERATE_DATA_QUALITY_REPORT: (literal: string) => {
            return `${API_URL}/v1/experiments/find-data-quality/${literal}`
        },
        MARK_AS_BU_PRIORITY: (literal: string) => {
            return `${API_URL}/v1/experiments/mark-bu-prioritizes/${literal}`
        },
        SHARABLE_USER_LIST: (literal: string) => {
            return `${API_URL}/v1/experiments/share/sharable-country-user-list/${literal}?page=1&per_page=9999`
        },
        EXPERIMENTS_SHARED_WITH_ME: `${API_URL}/v1/experiments/shared-experiment`,
        GET_RECURRING_TABLE_DATA_PREVIEW: (literal: string) => {
            return `${API_URL}/v1/experiments/recurring-new-measurement-preview-data/${literal}`
        },
        GET_RECURRING_COLUMNS_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/recurring-get-columns-for-measurement-group-distribution/${literal}`
        },
        GET_RECURRING_REQUIRED_COLUMN_LIST: (literal: string) => {
            return `${API_URL}/v1/experiments/get-recurring-experiment-required-column-list/${literal}`
        },
        GET_RECURRING_MEASUREMENT_GROUP_DISTRIBUTION_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/recurring-measurement-group-distribution-details/${literal}`
        },
        UPDATE_RECURRING_EXPERIMENT: (literal: string) => {
            return `${API_URL}/v1/experiments/update-recurring-measurement-config/${literal}`
        },
        UPDATE_KPI_DIRECTION: (literal: string) => {
            return `${API_URL}/v1/experiments/update-kpi-direction/${literal}`
        },
        GET_EXPERIMENT_INSIDE_METHODOLOGY: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/methodology/${literal}`
        },
        GET_SCHEDULE_DATES_FOR_RECURRING_EXPERIMENT: (literal: string) => {
            return `${API_URL}/v1/experiments/get-schedule-dates-for-recurring-experiment/${literal}`
        },
        DELETE_RECURRING_EXPERIMENT_CHILD: (literal: string) => {
            return `${API_URL}/v1/experiments/delete-recurring-experiment-child/${literal}`
        },
        UPDATE_RECURRING_DATE_CONFIG: (literal: string) => {
            return `${API_URL}/v1/experiments/update-recurring-date-config/${literal}`
        },
        DELETE_EXPERIMENT_CHILD: (literal: string) => {
            return `${API_URL}/v1/experiments/delete-recurring-experiment-child/${literal}`
        },
        GET_EXPERIMENT_MASTER_DECISION: `${API_URL}/v1/experiment-decision?sort_by=code`,
        SAVE_EXPERIMENT_DECISION: `${API_URL}/v1/experiments/add-decision`,
        EXPERIMENT_EDIT: (literal: string) => {
            return `${API_URL}/v1/experiments/${literal}/edit`
        },
    },
    TOPLEARNING: {
        LEARNINGS: API_URL + '/v1/executive-dashboard/learnings',
    },
    KPI: {
        KPI_IMPACTS: `${API_URL}/v1/experiments/insights/kpi-impacts`,
        AVG_METRIC: `${API_URL}/v1/experiments/insights/avg-metrics`,
        AVG_NET_REVENUE_PER_POC_PER_DAY: `${API_URL}/v1/experiments/insights/average-kpi-per-granularity-per-day`,
        AVG_KPI_PER_INTERVENTION: (literal: string) => `${API_URL}/v1/experiments/mte/avg-kpi-per-intervention/${literal}`,
        INTERVENTION_COMBINATION: (literal: string) => `${API_URL}/v1/experiments/mte/intervention-combination/${literal}`,
    },
    SELFSERVICE: {
        SELF_SERVICE_DROPDOWN: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/columns/${literal}`
        },
        SELF_SERVICE_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/data/${literal}`
        },
        SAVE_SELFSERVICE_DATA: (literal: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/save-filter/${literal}`
        },
        GET_SELF_SERVICE_DATA_COLUMN: (literal: string, column_name: string) => {
            return `${API_URL}/v1/experiments/insights/self-service/column-wise-distinct-data/${literal}?column_name=${column_name}`
        },
    },
    DEEPDIVE: {
        INSIGHT_OVERVIEW: `${API_URL}/v1/experiments/insights/deep-drive/overview`,
        AVG_METRIC: `${API_URL}/v1/experiments/insights/deep-drive/avg-metric-post-intervention`,
    },
    BLOCKING_FACTOR: {
        GET_BLOCKING_FACTOR_DATA: `${API_URL}/v1/experiments/insights/blocking-factors`,
    },

    NOTIFICATION: {
        GET_NOTIFICATIONS: `${API_URL}/v1/notifications`,
        MARK_ALL_READ: `${API_URL}/v1/notifications/mark-all-read`,
        NOTIFICATION_DELETE: `${API_URL}/v1/notifications`,
    },

    USERS: {
        GET_USERS: `${API_URL}/v1/users`,
        DELETE_USERS: (literal: string) => `${API_URL}/v1/users/${literal}`,
        UPDATE_USER: (literal: string) => `${API_URL}/v1/users/${literal}`,
        USER_ACTIONS: `${API_URL}/v1/users/actions`,
        GET_UPDATE_REQUESTED_USERS: `${API_URL}/v1/users/actions/profile-update-requests`,
        UPDATE_REQUESTED_USER_ACTION: `${API_URL}/v1/users/actions/profile-update-requests-action`,
        GET_BUSINESS_OWNER_DETAILS: (literal: string) => {
            return `${API_URL}/v1/business-owner/${literal}`
        },
        GET_TESTOPS_COPILOT_TOKEN: `${API_URL}/v1/genai/login`,
        SET_LANGUAGE: `${API_URL}/v1/users/language/update`,
    },

    ONBOARDING: {
        SUBMIT_ONBOARDING_DATA_REQUEST: `${API_URL}/v1/user-onboard-datasets/`,
        GET_ONBOARDING_DATA_LIST: `${API_URL}/v1/user-designs`,
        DELETE_ONBOARDING_DATA: (literal: string) => `${API_URL}/v1/user-designs/${literal}`,
        UPDATE_ONBOARDING_DATA: (literal: string) => `${API_URL}/v1/user-designs/${literal}`,
        GET_ONBOARDING_DATA_BY_ID: (literal: string) => `${API_URL}/v1/user-designs/${literal}`,
        CREATE_ONBOARDING_DATA: `${API_URL}/v1/user-designs/create`,
    },

    EXECUTIVE_DASHBOARD: {
        GET_TOP_CARDS: `${API_URL}/v1/executive-dashboard/dashboard-data`,
        GET_PIE_CHART: `${API_URL}/v1/executive-dashboard/pie-chart`,
        GET_EXPERIMENT_FROM_THE_MARKET: `${API_URL}/v1/executive-dashboard/top-experiments-from-the-market`,
        GET_TOP_LEARNINGS: `${API_URL}/v1/executive-dashboard/learnings`,
        GET_EXPERIMENT_FOR_ALL_USERS: `${API_URL}/v1/executive-dashboard/experiments-from-others`,
        GET_TOP_ACTIVE_USERS: `${API_URL}/v1/executive-dashboard/top-active-users`,
        DASHBOARD_CARDS: `${API_URL}/v1/executive-dashboard/dashboard-cards`,
        DASHBOARD_FUNNEL: `${API_URL}/v1/executive-dashboard/dashboard-funnel`,
        DASHBOARD_FUNNEL_EXP_LIST: `${API_URL}/v1/executive-dashboard/dashboard-funnel-exp-list`,
        DASHBOARD_BAR_CHART: `${API_URL}/v1/executive-dashboard/dashboard-bar-chart`,
    },

    EXPERIMENT_FILES: {
        UPLOAD_FILE: `${API_URL}/v1/files/upload`,
        MAP_EXPERIMENT_FILES: `${API_URL}/v1/files/map-experiment-file`,
        DELETE_FILES: (literal: string, file_id: number) => `${API_URL}/v1/v1/file/${literal}/${file_id}`,
        DOWNLOAD_FILES: (file_id: number) => {
            return `${API_URL}/v1/files/download/${file_id}`
        },
    },
    LARGE_UPLOAD: {
        INIT: `${API_URL}/v1/experiments/large-upload/init`,
        UPLOAD_CHUNK: `${API_URL}/v1/experiments/large-upload/chunk`,
        COMPLETE: (upload_id: string) => `${API_URL}/v1/experiments/large-upload/${upload_id}/complete`,
        GET_STATUS: (upload_id: string) => `${API_URL}/v1/experiments/large-upload/${upload_id}/status`,
        PROCESS: (upload_id: string) => `${API_URL}/v1/experiments/large-upload/${upload_id}/process`,
        REJECT: (upload_id: string) => `${API_URL}/v1/experiments/large-upload/${upload_id}/reject`,
    },
    CONTROL_CENTER: {
        GET_ALL_EXPERIMENTS: `${API_URL}/v1/control-center/get-all-experiments`,
        MARK_AS_TOP_LEARNING: (literal: string, learning_status: string) => `${API_URL}/v1/control-center/mark-experimrnt-as-top-learning/${literal}/${learning_status}`,
        DELETE_EXPERIMENT: (literal: string) => `${API_URL}/v1/control-center/${literal}`,
        RESTORE_EXPERIMENT: (literal: string) => `${API_URL}/v1/control-center/restore-experiment/${literal}`,
        MARK_AS_EXECUTIVE_DASHBOARD_EXPERIMENT: (experiment_literal: string, mark_as_executive_dashboard_experiment: boolean) =>
            `${API_URL}/v1/control-center/experiment/mark-experimrnt-as-executive-dashboard-experiment/${experiment_literal}/${mark_as_executive_dashboard_experiment}`,
    },
    PREEXISTING_TEMPLATE: {
        GET_TEMPLATE: `${API_URL}/v1/experiment-templatesget-all-templates`,
    },
}

export const ACTIONS = {
    RESET_REDUCER: 'ACTIONS/RESET_REDUCER',
    DIALOG: 'ACTIONS/DIALOG',

    LOADER: {
        FP_STATUS: 'ACTIONS/LOADER/FP_STATUS',
        LANG: 'ACTIONS/LOADER/LANG',
    },
    WORKERS: {
        DATA_PROCESSING: 'ACTIONS/WORKERS/DATA_PROCESSING',
        MEASUREMENT_DATA_PROCESSING: 'ACTIONS/WORKERS/MEASUREMENT_DATA_PROCESSING',
    },

    USER: {
        SSO_INITIATE: 'ACTIONS/USER/SSO_INITIATE',
        LOGIN: 'ACTIONS/USER/LOGIN',
        USER: 'ACTIONS/USER/USER',
        LOGOUT: 'ACTIONS/USER/LOGOUT',
        FORGET_PASSWORD: 'ACTIONS/USER/FORGET_PASSWORD',
        RESET_PASSWORD: 'ACTIONS/USER/RESET_PASSWORD',
        PASSWORD_RESET: 'ACTIONS/USER/PASSWORD_RESET',
        REGISTERINITIATE: 'ACTIONS/USER/REGISTERINITIATE',
        UPDATE_USER: 'ACTIONS/USER/UPDATE_USER',
    },
    EXPERIMENT: 'ACTIONS/EXPERIMENT',
    SET_INSIGHT_INPUTS: 'ACTIONS/SET_INSIGHT_INPUTS',
}

export const SAGA_ACTIONS = {
    USER: {
        SSO_INITIATE: 'SAGA_ACTIONS/USER/SSO_INITIATE',
        SSO_VERIFY: 'SAGA_ACTIONS/USER/SSO_VERIFY',
        LOGIN: 'SAGA_ACTIONS/USER/LOGIN',
        LOGOUT: 'SAGA_ACTIONS/USER/LOGOUT',
        FORGET_PASSWORD: 'SAGA_ACTIONS/USER/FORGET_PASSWORD',
        RESET_PASSWORD: 'SAGA_ACTIONS/USER/RESET_PASSWORD',
        REGISTER: 'SAGA_ACTIONS/USER/REGISTER',
        REGISTERINITIATE: 'SAGA_ACTIONS/USER/REGISTERINITIATE',
        UPDATE_USER: 'SAGA_ACTIONS/USER/UPDATE_USER',
        UPDATE_PROFILE: 'SAGA_ACTIONS/USER/UPDATE_PROFILE',
        GET_UPDATE_REQUESTED_USERS: 'SAGA_ACTIONS/USER/GET_UPDATE_REQUESTED_USERS',
        UPDATE_REQUESTED_USER_ACTION: 'SAGA_ACTIONS/USER/UPDATE_REQUESTED_USER_ACTION',
        GET_BUSINESS_OWNER_DETAILS: 'SAGA_ACTIONS/USER/GET_BUSINESS_OWNER_DETAILS',
        GET_TESTOPS_COPILOT_TOKEN: 'SAGA_ACTIONS/USER/GET_TESTOPS_COPILOT_TOKEN',
        SET_LANGUAGE: 'SAGA_ACTIONS/USER/SET_LANGUAGE',
    },
    LANDING_PAGE: {
        SUMMARY: 'SAGA_ACTIONS/LANDING_PAGE/SUMMARY',
        SITE_SETTINGS: 'SAGA_ACTIONS/LANDING_PAGE/SITE_SETTINGS',
        CONTACT_US: 'SAGA_ACTIONS/LANDING_PAGE/CONTACT_US',
    },
    COMMON: {
        COUNTRY: 'SAGA_ACTIONS/COMMON/COUNTRY',
        ZONE: 'SAGA_ACTIONS/COMMON/ZONE',
        ALLDROPDOWN: 'SAGA_ACTIONS/COMMON/ALLDROPDOWN',
        ROLE: 'SAGA_ACTIONS/COMMON/ROLE',
        BUSINESS_FUNCTION: 'SAGA_ACTIONS/COMMON/BUSINESS_FUNCTION',
        USE_CASES: 'SAGA_ACTIONS/COMMON/USE_CASES',
        KPI_INTERESTS: 'SAGA_ACTIONS/COMMON/KPI_INTERESTS',
        KPI_TYPES: 'SAGA_ACTIONS/COMMON/KPI_TYPES',
        EXPERIMENTS_TYPES: 'SAGA_ACTIONS/COMMON/EXPERIMENTS_TYPES',
        USERS: 'SAGA_ACTIONS/COMMON/USERS',
        EXPT_SHARABLE_USER: 'SAGA_ACTIONS/COMMON/EXPT_SHARABLE_USER',
        TOP_ACTIVE_USERS: 'SAGA_ACTIONS/COMMON/TOP_ACTIVE_USERS',
        DROPDOWN_EXPERIMENT_STATUS: 'SAGA_ACTIONS/COMMON/DROPDOWN_EXPERIMENT_STATUS',
        ADVANCE_CONFIG_OPTION: 'SAGA_ACTIONS/COMMON/ADVANCE_CONFIG_OPTION',
        PRODUCT_INFO: 'SAGA_ACTIONS/COMMON/PRODUCT_INFO',
        GET_CURRENCY: 'SAGA_ACTIONS/COMMON/GET_CURRENCY',
        GET_VOLUME: 'SAGA_ACTIONS/COMMON/GET_VOLUME',
        GET_EXPERIMENT_ACCESS: 'SAGA_ACTIONS/COMMON/GET_EXPERIMENT_ACCESS',
        GET_ADVANCE_CONFIG_OPTION: 'SAGA_ACTIONS/COMMON/GET_ADVANCE_CONFIG_OPTION',
    },
    EXPERIMENT: {
        CREATE_DESIGN: 'SAGA_ACTIONS/EXPERIMENT/CREATE_DESIGN',
        ZONE_DESIGN: 'SAGA_ACTIONS/EXPERIMENT/ZONE_DESIGN',
        USER_DESIGN: 'SAGA_ACTIONS/EXPERIMENT/USER_DESIGN',
        ZONE_DESIGN_DETAILS: 'SAGA_ACTIONS/EXPERIMENT/ZONE_DESIGN_DETAILS',
        GET_EXPERIMENTS: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENTS',
        GET_EXPERIMENT_DETAILS: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENT_DETAILS',
        GET_CONTAMINATION_CHECK: 'SAGA_ACTIONS/EXPERIMENT/GET_CONTAMINATION_CHECK',
        POST_CONTAMINATION_SNAPSHOT: 'SAGA_ACTIONS/EXPERIMENT/POST_CONTAMINATION_SNAPSHOT',
        UPDATE_CONTAMINATION_SELECTION: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_CONTAMINATION_SELECTION',
        DELETE_CONTAMINATION_SNAPSHOT: 'SAGA_ACTIONS/EXPERIMENT/DELETE_CONTAMINATION_SNAPSHOT',
        GET_EXPERIMENT_DETAILS_WATCH: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENT_DETAILS_WATCH',
        GET_FILTER_RESTORE_DETAILS: 'SAGA_ACTIONS/EXPERIMENT/GET_FILTER_RESTORE_DETAILS',
        RECURRING_FILE_PROCESS_WATCH: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_FILE_PROCESS_WATCH',
        GET_EXPERIMENTS_OTHERS: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENTS_OTHERS',
        UPDATE_EXPERIMENT: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_EXPERIMENT',
        GET_COLUMN_PREVIEW_DATA: 'SAGA_ACTIONS/EXPERIMENT/GET_COLUMN_PREVIEW_DATA',
        FILTER_PREVIEW_DATA: 'SAGA_ACTIONS/EXPERIMENT/FILTER_PREVIEW_DATA',
        SQL_PREVIEW_DATA: 'SAGA_ACTIONS/EXPERIMENT/SQL_PREVIEW_DATA',
        USER_DESIGN_CREATE: 'SAGA_ACTIONS/EXPERIMENT/USER_DESIGN_CREATE',
        RECURRING_EXPERIMENT_CREATE: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_EXPERIMENT_CREATE',
        RECURRING_EXPERIMENT_UPDATE: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_EXPERIMENT_UPDATE',
        RECURRING_UPDATE_DESIGN_TABLE: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_UPDATE_DESIGN_TABLE',
        RECURRING_GET_DESIGN_TABLE_COLUMNS: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_GET_DESIGN_TABLE_COLUMNS',
        RECURRING_GET_DESIGN_PREVIEW_DATA: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_GET_DESIGN_PREVIEW_DATA',
        RECURRING_UPDATE_DESIGN_CONFIG: 'SAGA_ACTIONS/EXPERIMENT/RECURRING_UPDATE_DESIGN_CONFIG',
        UPLOAD_FILE: 'SAGA_ACTIONS/EXPERIMENT/UPLOAD_FILE',
        UPLOAD_RECURRING_MEASUREMENT_FILE: 'SAGA_ACTIONS/EXPERIMENT/UPLOAD_RECURRING_MEASUREMENT_FILE',
        UPLOAD_ADDITIONAL_DATA_FILE: 'SAGA_ACTIONS/EXPERIMENT/UPLOAD_ADDITIONAL_DATA_FILE',
        MAP_ADDITIONAL_DATA_FILE: 'SAGA_ACTIONS/EXPERIMENT/MAP_ADDITIONAL_DATA_FILE',

        REMOVE_EXPERIMENT: 'SAGA_ACTIONS/EXPERIMENT/REMOVE_EXPERIMENT',
        CANCEL_EXPERIMENT: 'SAGA_ACTIONS/EXPERIMENT/CANCEL_EXPERIMENT',
        GET_RCT_GROUP_RESULTS: 'SAGA_ACTIONS/EXPERIMENT/GET_RCT_GROUP_RESULTS',
        EXPORT_RCT_GROUP_RESULTS: 'SAGA_ACTIONS/EXPERIMENT/EXPORT_RCT_GROUP_RESULTS',
        PROCESS_VALIDATED_DATA: 'SAGA_ACTIONS/EXPERIMENT/PROCESS_VALIDATED_DATA',
        MEASUREMENT_DATA: 'SAGA_ACTIONS/EXPERIMENT/MEASUREMENT_DATA',
        CARDS: 'SAGA_ACTIONS/EXPERIMENT/CARDS',
        DML_DATA: 'SAGA_ACTIONS/EXPERIMENT/DML_DATA',
        MTE_CARDS: 'SAGA_ACTIONS/EXPERIMENT/MTE_CARDS',
        DETAIL_ANALYSIS_DATA: 'SAGA_ACTIONS/EXPERIMENT/DETAIL_ANALYSIS_DATA',
        SHARED_USERS: 'SAGA_ACTIONS/EXPERIMENT/SHARED_USERS',
        SHARE_EXPT_TO_USERS: 'SAGA_ACTIONS/EXPERIMENT/SHARE_EXPT_TO_USERS',
        EXECUTE_RCT: 'SAGA_ACTIONS/EXPERIMENT/EXECUTE_RCT',
        EXECUTE_RCT_RESULTS: 'SAGA_ACTIONS/EXPERIMENT/EXECUTE_RCT_RESULTS',
        GET_COLUMNS_FOR_GROUP_DISTRIBUTION: 'SAGA_ACTIONS/EXPERIMENT/GET_COLUMNS_FOR_GROUP_DISTRIBUTION',
        GET_DESIGN_KPI_MEASURMENT: 'SAGA_ACTIONS/EXPERIMENT/GET_DESIGN_KPI_MEASURMENT',
        EXECUTE_MEASURMENT_ANALYSIS: 'SAGA_ACTIONS/EXPERIMENT/EXECUTE_MEASURMENT_ANALYSIS',
        MEASURMENT_DESIGN_MERGE_OVERVIEW: 'SAGA_ACTIONS/EXPERIMENT/MEASURMENT_DESIGN_MERGE_OVERVIEW',

        GET_EXEPERIMENT_PIE_CHART: 'SAGA_ACTIONS/EXPERIMENT/GET_EXEPERIMENT_PIE_CHART',
        GET_EXPERIMENT_FROM_THE_MARKET: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENT_FROM_THE_MARKET',
        MTE_SUBMIT: 'SAGA_ACTIONS/EXPERIMENT/MTE_SUBMIT',
        PLAY_OR_PAUSE: 'SAGA_ACTIONS/EXPERIMENT/PLAY_OR_PAUSE',
        MEASUREMENT_GROUP_DISTRIBUTION_DATA: 'SAGA_ACTIONS/EXPERIMENT/MEASUREMENT_GROUP_DISTRIBUTION_DATA',
        MIGRATE_MEASUREMENT_DATA_TO_CSV: 'SAGA_ACTIONS/EXPERIMENT/MIGRATE_MEASUREMENT_DATA_TO_CSV',
        DOWNLOAD_RCT_GROUP_RESULTS: 'SAGA_ACTIONS/EXPERIMENT/DOWNLOAD_RCT_GROUP_RESULTS',
        DOWNLOAD_RCT_GZIP_RESULTS: 'SAGA_ACTIONS/EXPERIMENT/DOWNLOAD_RCT_GZIP_RESULTS',
        DESIGN_GROUP_DISTRIBUTION_DETAILS: 'SAGA_ACTIONS/EXPERIMENT/DESIGN_GROUP_DISTRIBUTION_DETAILS',
        GET_KPI_CHART_DATA_BY_DATE: 'SAGA_ACTIONS/EXPERIMENT/GET_KPI_CHART_DATA_BY_DATE',
        GET_OBS_FEATURE_DISTRIBUTION_BAR_CHART: 'SAGA_ACTIONS/EXPERIMENT/GET_OBS_FEATURE_DISTRIBUTION_BAR_CHART',
        SAMPLE_SIZE_CALCULATE: 'SAGA_ACTIONS/EXPERIMENT/SAMPLE_SIZE_CALCULATE',
        AVG_METRIC_DESIGN: 'SAGA_ACTIONS/EXPERIMENT/AVG_METRIC_DESIGN',
        ATTACHMENT: {
            UPLOAD: 'SAGA_ACTIONS/EXPERIMENT/ATTACHMENT/UPLOAD',
            MAP: 'SAGA_ACTIONS/EXPERIMENT/ATTACHMENT/MAP',
            DELETE: 'SAGA_ACTIONS/EXPERIMENT/ATTACHMENT/DELETE',
            GET: 'SAGA_ACTIONS/EXPERIMENT/ATTACHMENT/GET',
        },
        ADDITIONAL_FILE_UPLOAD: 'SAGA_ACTIONS/EXPERIMENT/ADDITIONAL_FILE_UPLOAD',
        ADDITIONAL_TABLE_DATA: 'SAGA_ACTIONS/EXPERIMENT/ADDITIONAL_TABLE_DATA',
        GET_COMMENTS: 'SAGA_ACTIONS/EXPERIMENT/GET_COMMENTS',
        POST_COMMENT: 'SAGA_ACTIONS/EXPERIMENT/POST_COMMENT',
        GET_INCONCLUSIVE_REASON: 'SAGA_ACTIONS/EXPERIMENT/GET_INCONCLUSIVE_REASON',
        DOWNLOAD_LOG: 'SAGA_ACTIONS/EXPERIMENT/DOWNLOAD_LOG',
        MAKE_PARTIAL: 'SAGA_ACTIONS/EXPERIMENT/MAKE_PARTIAL',
        DELETE_INSIGHTS: 'SAGA_ACTIONS/EXPERIMENT/DELETE_INSIGHTS',
        EXPERIMENT_DROPDOWN: 'SAGA_ACTIONS/EXPERIMENT/EXPERIMENT_DROPDOWN',
        UPDATE_KPI_UNIT: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_KPI_UNIT',
        GENERATE_DATA_QUALITY_REPORT: 'SAGA_ACTIONS/EXPERIMENT/GENERATE_DATA_QUALITY_REPORT',
        MARK_AS_BU_PRIORITY: 'SAGA_ACTIONS/EXPERIMENT/MARK_AS_BU_PRIORITY',
        SHARABLE_USER_LIST: 'SAGA_ACTIONS/EXPERIMENT/SHARABLE_USER_LIST',
        EXPERIMENTS_SHARED_WITH_ME: 'SAGA_ACTIONS/EXPERIMENT/EXPERIMENTS_SHARED_WITH_ME',
        GET_RECURRING_TABLE_DATA_PREVIEW: 'SAGA_ACTIONS/EXPERIMENT/GET_RECURRING_TABLE_DATA_PREVIEW',
        GET_RECURRING_COLUMNS_DATA: 'SAGA_ACTIONS/EXPERIMENT/GET_RECURRING_COLUMNS_DATA',
        GET_RECURRING_REQUIRED_COLUMN_LIST: 'SAGA_ACTIONS/EXPERIMENT/GET_RECURRING_REQUIRED_COLUMN_LIST',
        GET_RECURRING_MEASUREMENT_GROUP_DISTRIBUTION_DATA: 'SAGA_ACTIONS/EXPERIMENT/GET_RECURRING_MEASUREMENT_GROUP_DISTRIBUTION_DATA',
        UPDATE_RECURRING_EXPERIMENT: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_RECURRING_EXPERIMENT',
        UPDATE_KPI_DIRECTION: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_KPI_DIRECTION',
        GET_EXPERIMENT_INSIDE_METHODOLOGY: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENT_INSIDE_METHODOLOGY',
        GET_SCHEDULE_DATES_FOR_RECURRING_EXPERIMENT: 'SAGA_ACTIONS/EXPERIMENT/GET_SCHEDULE_DATES_FOR_RECURRING_EXPERIMENT',
        DELETE_RECURRING_EXPERIMENT_CHILD: 'SAGA_ACTIONS/EXPERIMENT/DELETE_RECURRING_EXPERIMENT_CHILD',
        UPDATE_RECURRING_DATE_CONFIG: 'SAGA_ACTIONS/EXPERIMENT/UPDATE_RECURRING_DATE_CONFIG',
        DELETE_EXPERIMENT_CHILD: 'SAGA_ACTIONS/EXPERIMENT/DELETE_EXPERIMENT_CHILD',
        GET_EXPERIMENT_MASTER_DECISION: 'SAGA_ACTIONS/EXPERIMENT/GET_EXPERIMENT_MASTER_DECISION',
        SAVE_EXPERIMENT_DECISION: 'SAGA_ACTIONS/EXPERIMENT/SAVE_EXPERIMENT_DECISION',
        EXPERIMENT_EDIT: 'SAGA_ACTIONS/EXPERIMENT/EXPERIMENT_EDIT',
    },
    TOP_LEARNINGS: {
        GET_LEARNINGS: 'SAGA_ACTIONS/EXPERIMENT/GET_LEARNINGS',
    },
    KPI: {
        KPI_IMPACTS: 'SAGA_ACTIONS/KPI/KPI_IMPACTS',
        AVG_METRIC: 'SAGA_ACTIONS/KPI/AVG_METRIC',
        AVG_NET_REVENUE_PER_POC_PER_DAY: 'SAGA_ACTIONS/KPI/AVG_NET_REVENUE_PER_POC_PER_DAY',
        AVG_KPI_PER_INTERVENTION: 'SAGA_ACTIONS/KPI/AVG_KPI_PER_INTERVENTION',
        INTERVENTION_COMBINATION: 'SAGA_ACTIONS/KPI/INTERVENTION_COMBINATION',
    },
    SELF_SERVICE: {
        GET_SELF_SERVICE_DROPDOWN_DATA: 'SAGA_ACTIONS/SELF_SERVICE/GET_SELF_SERVICE_DROPDOWN_DATA',
        GET_SELF_SERVICE_DATA: 'SAGA_ACTIONS/SELF_SERVICE/GET_SELF_SERVICE_DATA',
        SAVE_SELFSERVICE_DATA: 'SAGA_ACTIONS/SELF_SERVICE/SAVE_SELFSERVICE_DATA',
        GET_SELF_SERVICE_DATA_COLUMN: 'SAGA_ACTIONS/SELF_SERVICE/GET_SELF_SERVICE_DATA_COLUMN',
    },
    DEEP_DIVE: {
        INSIGHT_OVERVIEW: 'SAGA_ACTIONS/DEEP_DIVE/INSIGHT_OVERVIEW',
        AVG_METRIC: 'SAGA_ACTIONS/DEEP_DIVE/AVG_METRIC',
    },
    BLOCKING_FACTOR: {
        GET_BLOCKING_FACTOR_DATA: 'SAGA_ACTIONS/BLOCKING_FACTOR/GET_BLOCKING_FACTOR_DATA',
    },

    NOTIFICATION: {
        GET_NOTIFICATIONS: 'SAGA_ACTIONS/NOTIFICATION/GET_NOTIFICATIONS',
        MARK_ALL_READ: 'SAGA_ACTIONS/NOTIFICATION/MARK_ALL_READ',
        NOTIFICATION_DELETE: 'SAGA_ACTIONS/NOTIFICATION/NOTIFICATION_DELETE',
    },
    ADMIN: {
        GET_ALL_USERS: 'SAGA_ACTIONS/ADMIN/GET_ALL_USERS',
        DELETE_USER: 'SAGA_ACTIONS/ADMIN/DELETE_USER',
        UPDATE_USER: 'SAGA_ACTIONS/ADMIN/UPDATE_USER',
        USER_ACTIONS: 'SAGA_ACTIONS/ADMIN/USER_ACTIONS',
    },
    CREATE_ONBOARDING: {
        SUBMIT_ONBOARDING_DATA_REQUEST: 'SAGA_ACTION/ONBOARDING/SUBMIT_ONBOARDING_DATA_REQUEST',
        ONBOARDING_DATA_LIST: 'SAGA_ACTION/ONBOARDING/ONBOARDING_DATA_LIST',
        ONBOARDING_DATA_DELETE: 'SAGA_ACTION/ONBOARDING/ONBOARDING_DATA_DELETE',
        CREATE: 'SAGA_ACTION/ONBOARDING/CREATE',
        GET_BY_ID: 'SAGA_ACTION/ONBOARDING/GET_BY_ID',
        UPDATE: 'SAGA_ACTION/ONBOARDING/UPDATE',
    },
    EXECUTIVE_DASHBOARD: {
        TOP_CARDS: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/TOP_CARDS',
        GET_EXPERIMENT_FROM_THE_MARKET: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/GET_EXPERIMENT_FROM_THE_MARKET',
        GET_EXEPERIMENT_PIE_CHART: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/GET_EXEPERIMENT_PIE_CHART',
        GET_TOP_LEARNINGS: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/GET_TOP_LEARNINGS',
        GET_EXPERIMENTS_SUMMARY_OF_USERS: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/GET_EXPERIMENTS_SUMMARY_OF_USERS',
        TOP_ACTIVE_USERS: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/TOP_ACTIVE_USERS',
        DASHBOARD_CARDS: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/DASHBOARD_CARDS',
        DASHBOARD_FUNNEL: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/DASHBOARD_FUNNEL',
        DASHBOARD_FUNNEL_EXP_LIST: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/DASHBOARD_FUNNEL_EXP_LIST',
        DASHBOARD_BAR_CHART: 'SAGA_ACTIONS/EXECUTIVE_DASHBOARD/DASHBOARD_BAR_CHART',
    },

    EXPERIMENT_FILES: {
        UPLOAD_FILE: 'SAGA_ACTIONS/EXPERIMENT_FILES/UPLOAD_FILE',
        MAP_EXPERIMENT_FILES: 'SAGA_ACTIONS/EXPERIMENT_FILES/MAP_EXPERIMENT_FILES',
        DELETE_FILES: 'SAGA_ACTIONS/EXPERIMENT_FILES/DELETE_FILES',
        DOWNLOAD_FILES: 'SAGA_ACTIONS/EXPERIMENT_FILES/DOWNLOAD_FILES',
    },
    LARGE_UPLOAD: {
        INIT: 'SAGA_ACTIONS/LARGE_UPLOAD/INIT',
        UPLOAD_CHUNK: 'SAGA_ACTIONS/LARGE_UPLOAD/UPLOAD_CHUNK',
        COMPLETE: 'SAGA_ACTIONS/LARGE_UPLOAD/COMPLETE',
        GET_STATUS: 'SAGA_ACTIONS/LARGE_UPLOAD/GET_STATUS',
        PROCESS: 'SAGA_ACTIONS/LARGE_UPLOAD/PROCESS',
        REJECT: 'SAGA_ACTIONS/LARGE_UPLOAD/REJECT',
    },
    TESTOPS_GENIE: {
        CONVERSATION: 'SAGA_ACTIONS/TESTOPS_GENIE/CONVERSATION',
        CHAT: 'SAGA_ACTIONS/TESTOPS_GENIE/CHAT',
        GET_CHAT_BY_CONVERSATION_ID: 'SAGA_ACTIONS/TESTOPS_GENIE/GET_CHAT_BY_CONVERSATION_ID',
        GET_SUGGESTED_QUESTIONS: 'SAGA_ACTIONS/TESTOPS_GENIE/GET_SUGGESTED_QUESTIONS',
        ADD_USER: 'SAGA_ACTIONS/TESTOPS_GENIE/ADD_USER',
        GET_CONVERSATION_LIST: 'SAGA_ACTIONS/TESTOPS_GENIE/GET_CONVERSATION_LIST',
        GET_HISTORY: 'SAGA_ACTIONS/TESTOPS_GENIE/GET_HISTORY',
        CHAT_SOCKET: 'SAGA_ACTIONS/TESTOPS_GENIE/CHAT_SOCKET',
    },
    CHAT_TO_EXPERIMENT: {
        CREATE_SESSION: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/CREATE_SESSION',
        CHAT: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/CHAT',
        LIST_SESSIONS: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/LIST_SESSIONS',
        GET_SESSION_MESSAGES: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/GET_SESSION_MESSAGES',
        DELETE_SESSION: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/DELETE_SESSION',
        CHAT_STEPS_STREAM: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/CHAT_STEPS_STREAM',
        GET_SUPPORT_NOTE: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/GET_SUPPORT_NOTE',
        CREATE_FILTER_SESSION: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/CREATE_FILTER_SESSION',
        FILTER_CHAT: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/FILTER_CHAT',
        FILTER_GET_SESSION_MESSAGES: 'SAGA_ACTIONS/CHAT_TO_EXPERIMENT/FILTER_GET_SESSION_MESSAGES',
    },
    DS_AGENT: {
        CREATE_SESSION: 'SAGA_ACTIONS/DS_AGENT/CREATE_SESSION',
        CHAT: 'SAGA_ACTIONS/DS_AGENT/CHAT',
        LIST_SESSIONS: 'SAGA_ACTIONS/DS_AGENT/LIST_SESSIONS',
        GET_SESSION_MESSAGES: 'SAGA_ACTIONS/DS_AGENT/GET_SESSION_MESSAGES',
        DELETE_SESSION: 'SAGA_ACTIONS/DS_AGENT/DELETE_SESSION',
        SUBMIT_FEEDBACK: 'SAGA_ACTIONS/DS_AGENT/SUBMIT_FEEDBACK',
    },
    REQUIREMENT_AGENT: {
        CREATE_SESSION: 'SAGA_ACTIONS/REQUIREMENT_AGENT/CREATE_SESSION',
        CHAT: 'SAGA_ACTIONS/REQUIREMENT_AGENT/CHAT',
        LIST_SESSIONS: 'SAGA_ACTIONS/REQUIREMENT_AGENT/LIST_SESSIONS',
        GET_SESSION_MESSAGES: 'SAGA_ACTIONS/REQUIREMENT_AGENT/GET_SESSION_MESSAGES',
        DELETE_SESSION: 'SAGA_ACTIONS/REQUIREMENT_AGENT/DELETE_SESSION',
        SUBMIT_FEEDBACK: 'SAGA_ACTIONS/REQUIREMENT_AGENT/SUBMIT_FEEDBACK',
    },
    PLANNING_AGENT: {
        CREATE_SESSION: 'SAGA_ACTIONS/PLANNING_AGENT/CREATE_SESSION',
        CHAT: 'SAGA_ACTIONS/PLANNING_AGENT/CHAT',
        LIST_SESSIONS: 'SAGA_ACTIONS/PLANNING_AGENT/LIST_SESSIONS',
        GET_SESSION_MESSAGES: 'SAGA_ACTIONS/PLANNING_AGENT/GET_SESSION_MESSAGES',
        DELETE_SESSION: 'SAGA_ACTIONS/PLANNING_AGENT/DELETE_SESSION',
        SUBMIT_FEEDBACK: 'SAGA_ACTIONS/PLANNING_AGENT/SUBMIT_FEEDBACK',
    },
    DEVOPS_AGENT: {
        CREATE_SESSION: 'SAGA_ACTIONS/DEVOPS_AGENT/CREATE_SESSION',
        CHAT: 'SAGA_ACTIONS/DEVOPS_AGENT/CHAT',
        LIST_SESSIONS: 'SAGA_ACTIONS/DEVOPS_AGENT/LIST_SESSIONS',
        GET_SESSION_MESSAGES: 'SAGA_ACTIONS/DEVOPS_AGENT/GET_SESSION_MESSAGES',
        DELETE_SESSION: 'SAGA_ACTIONS/DEVOPS_AGENT/DELETE_SESSION',
        SUBMIT_FEEDBACK: 'SAGA_ACTIONS/DEVOPS_AGENT/SUBMIT_FEEDBACK',
    },
    CONTROL_CENTER: {
        GET_ALL_EXPERIMENTS: 'SAGA_ACTIONS/CONTROL_CENTER/GET_ALL_EXPERIMENTS',
        MARK_AS_TOP_LEARNING: 'SAGA_ACTIONS/CONTROL_CENTER/MARK_AS_TOP_LEARNING',
        DELETE_EXPERIMENT: 'SAGA_ACTIONS/CONTROL_CENTER/DELETE_EXPERIMENT',
        RESTORE_EXPERIMENT: 'SAGA_ACTIONS/CONTROL_CENTER/RESTORE_EXPERIMENT',
        MARK_AS_EXECUTIVE_DASHBOARD_EXPERIMENT: 'SAGA_ACTIONS/CONTROL_CENTER/MARK_AS_EXECUTIVE_DASHBOARD_EXPERIMENT',
    },
    PREEXISTING_TEMPLATE: {
        GET_TEMPLATE: 'SAGA_ACTIONS/PREEXISTING_TEMPLATE/GET_TEMPLATE',
    },
}

export const CHART_COLORS = ['#D69E77', '#E5C511', '#31596C']
export const graphColors: any = ['#E5C511', '#D69E77', '#c2c2c2', '#E5C511', '#D69E77']
export const ControlColorCode = '#F5E003'
export const SyntheticControlColorCode = '#00D1FF'
export const TestColorCode = '#2078A1'

export const getChartColor = (key: string = '', index: number | null = null) => {
    if (key.toLocaleLowerCase() == 'control') return ControlColorCode
    if (key.toLocaleLowerCase() == 'synthetic control' || key.toLocaleLowerCase() == 'cuped counterfactual' || key.toLocaleLowerCase() == 'counterfactual') return SyntheticControlColorCode
    if (key.toLocaleLowerCase() == 'test') return TestColorCode
    if (index !== null) {
        return graphColors[index % CHART_COLORS.length]
    }
    return TestColorCode
}

export enum EXPERIMENT_PROGRESS_STATUS {
    POSITIVE_LIFT = 'Positive_Lift',
    NEGATIVE_LIFT = 'Negative_Lift',
    INCONCLUSIVE = 'Inconclusive',
    NOIMPACT = 'No_impact',
}
export enum EXPERIMENT_STATUS {
    'IN_PROGRESS' = 100,
    'SUBMITTED' = 101,
    'SUCCESS' = 200,
    'FAILED' = 300,
    'CANCELLED' = 400,
    'INCONCLUSIVE' = 401,
}

export enum EXERIMENT_PLAY_PAUSE {
    PLAY = 'start',
    PAUSE = 'pause',
}

export const PaginationOptions = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '30', value: 30 },
]

export enum RECURRING_EXPT_STATUS {
    NEW = 1, // pause
    RUNNING = 2, // pause
    PAUSE = 3, // start
    COMPLETED = 4, // no optipn
}
